import Crud from "../Crud";
import MUIDeepOrangeColor from "@mui/material/colors/deepOrange";

/**
 * Static helper functions related to Accounts.
 */
export default class AccountType extends Crud {

    /**
     * @param {object} accountType The accountType object.
     * @returns The display name of the accountType.
     */
    static getDisplayName(accountType) {
        return accountType.name;
    }

    /**
     * Determines if a accountType matches a search query.
     *
     * @param {object} accountType The accountType to test.
     * @param {string} query The search query.
     * @returns {boolean} Whether or not the accountType matches the query.
     */
    static match(accountType, query) {
        return (
            (accountType.name !== null && accountType.name.toLowerCase().includes(query)) ||
            accountType.id === +query
        );
    }

    /**
     * @param {array} accountTypes The list to sort.
     * @returns {array} The sorted list.
     */
    static sort(accountTypes) {
        return accountTypes.sort((a, b) => {
            return (a.name).localeCompare(b.name);
        });
    }

    /**
     * @returns {string} The color of this object.
     */
    static getBaseColor() {
        return MUIDeepOrangeColor;
    }

    /**
     * @returns {string} The icon name for this object.
     */
    static getIconName() {
        return "AssignmentInd";
    }
}